import { Icon } from '@iconify/react';
import * as S from './style';

export type ModalNotaFiscalProps = {
  campanhaPedidoResgatePagamentoId: number;
  campanhaId: number;
}

export function ModalNotaFiscal(props: ModalNotaFiscalProps) {
  const { campanhaPedidoResgatePagamentoId, campanhaId } = props;

  return (
    <S.Container
      role="dialog"
      aria-labelledby="modal-title"
      aria-describedby="modal-content"
      tabIndex={-1}
    >
      <S.Header>
        <S.Title id="modal-title">Nota Fiscal</S.Title>
      </S.Header>

      <S.Content id="modal-content" role="document">
        <S.MessageContainer>
          <S.IconWrapper>
            <Icon icon="ph:info-fill" width={48} height={48} />
          </S.IconWrapper>
          <S.MessageTitle>Nota Fiscal em Processamento</S.MessageTitle>
          <S.MessageText>
            A Nota Fiscal será enviada no e-mail do usuário cadastrado assim que o processamento for concluído.
          </S.MessageText>
          <S.InfoText>
            <strong>ID do Pagamento:</strong> {campanhaPedidoResgatePagamentoId}
          </S.InfoText>
          <S.InfoText>
            <strong>ID da Campanha:</strong> {campanhaId}
          </S.InfoText>
        </S.MessageContainer>
      </S.Content>
    </S.Container>
  );
}

export default ModalNotaFiscal;
